module.exports = __webpack_public_path__ + "img/Singrunde_2_2018.eaff5ae0.jpg";